module.exports = __webpack_public_path__ + "media/images/common-nav/state-parks/georgia-c6b3fc05130bd2dd0e9f792ab3bd3b8d.jpg";